import {initSearch} from './search'

initSearch()
